// @ts-nocheck
/* eslint-disable no-return-assign */
/* eslint-disable import/no-unresolved */
/* eslint-disable no-plusplus */
/* eslint-disable no-undef */
import { LitElement, html, css } from 'lit';
import { i18n } from '@lingui/core';
// import { styles } from '@warp-ds/elements-core/global.js';
import { styles } from './temp-styles.js';
import '@fabric-ds/icons/elements/bell-24';
import '@fabric-ds/icons/elements/circle-plus-24';
import '@fabric-ds/icons/elements/messages-24';
import '@fabric-ds/icons/elements/user-24';

const menuItem = {
    NONE: 'NONE',
    FRONTPAGE: 'FRONTPAGE',
    INBOX: 'INBOX',
    NEW_AD: 'NEW_AD',
    NOTIFICATIONS: 'NOTIFICATIONS',
    PROFILE: 'PROFILE',
    MENU: 'MENU',
};

class FinnTopbar extends LitElement {
    constructor() {
        super();

        this._translationSupport = false;
    }

    get i18n() {
        if (!this._translationSupport) {
            i18n.load(this.locale, this.messages);
            i18n.activate(this.locale);
        }

        return i18n;
    }

    get locale() {
        return this.getAttribute('locale') || 'nb';
    }

    get messages() {
        return this.getAttribute('messages')
            ? JSON.parse(this.getAttribute('messages' || '{}'))
            : {};
    }

    get brand() {
        return this.getAttribute('brand') || 'FINN';
    }

    static get styles() {
        return [
            styles,
            css`
                :host {
                    width: 100%;
                    display: block;
                    height: 50px;
                    margin-bottom: 16px;
                }
                @warp-css;
            `,
        ];
    }

    static get properties() {
        return {
            loggedIn: { type: Boolean, attribute: 'logged-in' },
            activeMenuItem: { type: String, attribute: 'active-menu-item' },
            distractionFree: {
                type: Boolean,
                attribute: 'distraction-free',
            },
            sites: { type: String },
            legacyHeader: { type: Boolean, attribute: 'legacy-header' },
            hasNotifications: {
                type: Boolean,
                attribute: 'has-notifications',
                reflect: true,
            },
            messagesUnreadCount: {
                type: Number,
                attribute: 'message-unread-count',
                reflect: true,
            },
            show: { type: Boolean, reflect: true },
            profileImageURL: {
                type: String,
                attribute: 'profile-image-url',
                reflect: true,
            },
            profileName: {
                type: String,
                attribute: 'profile-name',
                reflect: true,
            },
            profileEmail: {
                type: String,
                attribute: 'profile-email',
                reflect: true,
            },
        };
    }

    connectedCallback() {
        super.connectedCallback();
        this._firstRender = true;
    }

    update() {
        super.update();
        // right after first render, set profile image from local storage if available
        // update hook is not called server side
        // cannot use connectedCallback as this messes with hydration
        if (this._firstRender === true) {
            if (this.loggedIn) {
                this.profileImageURL =
                    localStorage.getItem('profileImageURL') || '';
            }

            this._firstRender = false;
        }
    }

    set profileImageURL(val) {
        const oldVal = this._profileImageURL;
        this._profileImageURL = val;
        this.requestUpdate('profileImageURL', oldVal);
        localStorage.setItem('profileImageURL', val);
    }

    get profileImageURL() {
        return this._profileImageURL;
    }

    get _origin() {
        if (this.sites) return this.sites;
        return new URL(this.baseURI).origin;
    }

    _trackEventNewAd() {
        this.dispatchEvent(new Event('new-ad'));
    }

    _trackEventLogin() {
        this.dispatchEvent(new Event('login'));
    }

    _click() {
        this.show = !this.show;
        this.dispatchEvent(
            new CustomEvent('click', { detail: { show: this.show } }),
        );
    }

    get _legacyProfileImage() {
        const isActive = this.activeMenuItem === menuItem.PROFILE;
        if (
            this.profileImageURL &&
            !this.profileImageURL.includes('default.png')
        ) {
            return html`<img
                src="${this.profileImageURL}"
                class="top-bar__menu-item__profile-picture rounded-full"
                alt="${this.i18n.t({
                    id: 'topbar.profile-image.alt',
                    message: 'My profile image',
                    comment: 'Alt text used on the legacy profile image',
                })}"
                width="28"
                height="28"
            />`;
        }

        if (this.loggedIn) {
            return html`<img
                src="https://images.finncdn.no/dynamic/100x100c/profile_placeholders/default.png"
                class="top-bar__menu-item__profile-picture"
                alt=""
                width="28"
                height="28"
            />`;
        }

        return html`
            <f-icon-user24
                class="-mb-4 ${isActive ? 's-icon-primary' : 's-text-subtle'}"
            ></f-icon-user24>
        `;
    }

    get _legacyProfile() {
        const isActive = this.activeMenuItem === menuItem.PROFILE;
        if (this.loggedIn) {
            const myBrandMessage = this.i18n.t({
                id: 'topbar.link.profile',
                message: 'My {brand}',
                values: { brand: this.brand },
                comment:
                    'Message used in link, as aria label and shown in clear text to the user when linking to the users profile',
            });
            return html`<a
                href="${this._origin}/min-finn"
                class="${isActive
                    ? 's-border-primary-default'
                    : 'border-transparent'} justify-center p-0 flex-auto md:flex-none relative no-wrap min-width-0 py-0 px-10 ml-10 border-b-2 hover:s-border-primary-default focus:s-border-primary-default focus:outline-none flex items-center text-12 no-underline hover:no-underline focus:no-underline active:no-underline "
                aria-current="${isActive ? 'page' : 'false'}"
                aria-label="${myBrandMessage}"
                data-automation-id="profile-link"
                title="${myBrandMessage}"
            >
                <span data-hj-suppress id="topbar_profile-image"
                    >${this._legacyProfileImage}</span
                >
                <span
                    class="hidden md:block ml-8 text-gray-800 translate font-bold"
                    style="color: #474445;"
                    >${myBrandMessage}</span
                >
            </a>`;
        }

        const loginMessage = this.i18n.t({
            id: 'topbar.link.login',
            message: 'Log in',
            comment:
                'Message used in link, as aria label and shown in clear text to the user when linking to the login page',
        });
        return html`<a
            href="${this._origin}/auth/login"
            class="${isActive
                ? 's-border-primary-default'
                : 'border-transparent'} justify-center p-0 flex-auto md:flex-none relative no-wrap min-width-0 py-0 px-10 ml-10 border-b-2 border-b-2 hover:s-border-primary-default focus:s-border-primary-default focus:outline-none flex items-center text-12 no-underline hover:no-underline focus:no-underline active:no-underline "
            aria-current="${isActive ? 'page' : 'false'}"
            aria-label="${loginMessage}"
            data-automation-id="profile-link"
            title="${loginMessage}"
            @click=${this._trackEventLogin}
            rel="nofollow"
        >
            <span data-hj-suppress id="topbar_profile-image"
                >${this._legacyProfileImage}</span
            >
            <span
                class="hidden md:block ml-8 text-gray-800 translate font-bold"
                style="color: #474445;"
                >${loginMessage}</span
            >
        </a>`;
    }

    get _megaMenuButton() {
        const menuButtonAria = this.i18n.t({
            id: 'topbar.button.main-menu.aria-label',
            message: 'Main menu',
            comment: 'Aria label for the main menu button',
        });
        const menuButtonText = this.i18n.t({
            id: 'topbar.button.main-menu.text',
            message: 'Menu',
            comment: 'Button text for the main menu button',
        });
        return html`
            <button
                @click=${this._click}
                id="mega-menu-button"
                class="${this.show
                    ? 's-border-primary-default'
                    : 'border-transparent'} justify-center p-0 flex-auto md:flex-none relative no-wrap min-width-0 py-0 px-10 ml-10 border-b-2 hover:s-border-primary-default focus:s-border-primary-default focus:outline-none flex items-center text-12 no-underline hover:no-underline focus:no-underline active:no-underline "
                aria-current="${this.show ? 'page' : 'false'}"
                aria-expanded="${this.show}"
                aria-controls="${this.show ? 'mega-menu' : ''}"
                aria-label="${menuButtonAria}"
                title="${menuButtonAria}"
            >
                <!-- -->
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    height="24"
                    width="24"
                    class="mm-icon
                                    ${this.show ? 'open' : 'closed'}
                                    "
                >
                    <style>
                        @keyframes a0_t {
                            0% {
                                transform: translate(12px, 20px);
                                animation-timing-function: cubic-bezier(
                                    0.42,
                                    0,
                                    0.58,
                                    1
                                );
                            }

                            43.1034%,
                            to {
                                transform: translate(12px, 12px);
                            }
                        }

                        @keyframes three_t {
                            0% {
                                transform: rotate(0deg) translate(-12px, -20px);
                            }

                            56.8965% {
                                transform: rotate(0deg) translate(-12px, -20px);
                                animation-timing-function: cubic-bezier(
                                    0.42,
                                    0,
                                    0.58,
                                    1
                                );
                            }

                            to {
                                transform: rotate(45deg) translate(-12px, -20px);
                            }
                        }

                        @keyframes two_o {
                            0%,
                            43.1034% {
                                opacity: 1;
                            }

                            56.8966%,
                            to {
                                opacity: 0;
                            }
                        }

                        @keyframes a1_t {
                            0% {
                                transform: translate(12px, 4px);
                                animation-timing-function: cubic-bezier(
                                    0.42,
                                    0,
                                    0.58,
                                    1
                                );
                            }

                            43.1034%,
                            to {
                                transform: translate(12px, 12px);
                            }
                        }

                        @keyframes one_t {
                            0% {
                                transform: rotate(0deg) translate(-12px, -4px);
                            }

                            56.8965% {
                                transform: rotate(0deg) translate(-12px, -4px);
                                animation-timing-function: cubic-bezier(
                                    0.42,
                                    0,
                                    0.58,
                                    1
                                );
                            }

                            to {
                                transform: rotate(-45deg) translate(-12px, -4px);
                            }
                        }

                        .mm-icon.open .mm-icon_a {
                            animation: 0.58s linear both a0_t;
                        }
                        .mm-icon.open .mm-icon_aa {
                            animation: 0.58s linear both three_t;
                        }
                        .mm-icon.open .mm-icon_b {
                            animation: 0.58s linear both two_o;
                        }
                        .mm-icon.open .mm-icon_c {
                            animation: 0.58s linear both a1_t;
                        }
                        .mm-icon.open .mm-icon_ca {
                            animation: 0.58s linear both one_t;
                        }
                    </style>
                    <g
                        class="mm-icon_a"
                        xstyle="animation:.58s linear both a0_t"
                    >
                        <path
                            class="mm-icon_aa"
                            d="M3 20h18"
                            stroke="#767676"
                            stroke-width="1.5"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            xstyle="animation:.58s linear both three_t"
                            id="three"
                        />
                    </g>
                    <path
                        class="mm-icon_b"
                        id="two"
                        d="M3 12h18"
                        stroke="#767676"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        opacity="1"
                        xstyle="animation:.58s linear both two_o"
                    />
                    <g
                        class="mm-icon_c"
                        xstyle="animation:.58s linear both a1_t"
                    >
                        <path
                            class="mm-icon_ca"
                            d="M3 4h18"
                            stroke="#767676"
                            stroke-width="1.5"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            xstyle="animation:.58s linear both one_t"
                            id="one"
                        />
                    </g>
                </svg>
                <!-- -->

                <span
                    class="hidden md:block ml-8 s-text-default translate font-bold"
                    style="color: #474445;"
                    >${menuButtonText}</span
                >
            </button>
        `;
    }

    get _megaMenu() {
        if (this.legacyHeader) return html``;
        return html`<mega-menu
            profile-image-url=${this.profileImageURL}
            profile-name=${this.profileName}
            profile-email=${this.profileEmail}
            sites="${this.sites}"
            ?logged-in="${this.loggedIn}"
            ?show="${this.show}"
            locale="${this.locale}"
            messages="${JSON.stringify(this.messages)}"
        ></mega-menu>`;
    }

    get _logo() {
        switch (this.brand) {
            case 'TORI':
                return html`
                    <span class="sm:hidden">
                        <svg
                            focusable="false"
                            width="20"
                            height="26"
                            viewBox="0 0 20 26"
                        >
                            <title>Tori.fi</title>
                            <path
                                d="M19.9928 7.65029C20.0483 8.53944 19.7824 9.41862 19.2449 10.1229C18.7073 10.8272 17.9352 11.3082 17.0732 11.4757C16.481 11.5904 15.8702 11.5569 15.2936 11.3783C14.717 11.1996 14.1919 10.8811 13.7637 10.4503C13.3355 10.0194 13.0171 9.48919 12.836 8.90543C12.6549 8.32166 12.6166 7.70191 12.7243 7.09973C12.8779 6.22178 13.3412 5.43064 14.0275 4.87416C14.7138 4.31767 15.5762 4.03391 16.4536 4.0759C17.3774 4.11315 18.2538 4.50115 18.9092 5.1631C19.5646 5.82504 19.9513 6.71268 19.9928 7.65029ZM9.13788 0H3.81425V5.40714H0V10.2135H3.81425V17.9824C3.81425 23.1823 6.32308 25.9998 11.2184 25.9998C13.6158 26.013 15.9538 25.2428 17.8867 23.8029L15.6536 19.7542C14.5726 20.4172 13.3601 20.9656 12.0954 20.9656C10.4433 20.9656 9.13788 20.054 9.13788 17.5473V0Z"
                                fill="#F94F55"
                            />
                        </svg>
                    </span>
                    <span class="hidden sm:block">
                        <svg
                            focusable="false"
                            width="64"
                            height="31"
                            viewBox="0 0 64 31"
                        >
                            <title>Tori.fi</title>
                            <path
                                fill-rule="evenodd"
                                clip-rule="evenodd"
                                d="M63.9995 3.73685C63.9782 5.77281 62.3051 7.40873 60.2566 7.39666C58.208 7.38458 56.5545 5.72907 56.5575 3.69299C56.5605 1.65692 58.2189 0.00622056 60.2675 0.000108566C61.2644 -0.00749572 62.2224 0.384651 62.9247 1.08789C63.6271 1.79113 64.0145 2.74608 63.9995 3.73685ZM28.789 10.0024C22.5633 10.0024 17.9717 14.4901 17.9717 20.5011C17.9717 26.5122 22.5633 30.9999 28.789 30.9999C35.0353 30.9999 39.6476 26.5122 39.6476 20.5011C39.6476 14.4901 35.0353 10.0024 28.789 10.0024V10.0024ZM28.7892 15.0048C31.8296 15.0048 34.1254 17.2692 34.1254 20.5012C34.1254 23.7332 31.8296 25.9975 28.7892 25.9975C25.7487 25.9975 23.4736 23.7331 23.4736 20.5012C23.4736 17.2692 25.7488 15.0048 28.7892 15.0048V15.0048ZM52.4672 10.0021C50.0059 10.0021 48.0824 10.8462 46.8208 12.7194V10.5374H41.5879V30.485H46.9862V19.6157C46.9862 16.6514 49.3135 15.3133 52.091 15.3133C54.4125 15.3133 55.2801 15.7662 55.2801 15.7662V10.5374C54.3882 10.1729 53.4315 9.9909 52.4672 10.0021V10.0021ZM62.9974 10.5376H57.5991V30.4853H62.9974V10.5376ZM16.5259 10.5376H9.26606V5.16473H3.86775V10.5376H0V15.3135H3.86775V23.0332C3.86775 28.2002 6.41177 30.9999 11.3757 30.9999C13.8071 31.0129 16.1781 30.2475 18.1376 28.8169L15.8732 24.7938C14.777 25.4526 13.5475 25.9975 12.2651 25.9975C10.5898 25.9975 9.26607 25.0917 9.26607 22.6009V15.3135H16.5259L16.5259 10.5376Z"
                                fill="#F94F55"
                            />
                        </svg>
                    </span>
                `;
            default:
                return html`
                    <span class="sm:hidden">
                        <svg
                            focusable="false"
                            width="62"
                            height="32"
                            viewBox="0 0 124 64"
                        >
                            <title>FINN.no</title>
                            <path
                                fill="#06bffc"
                                d="M119.8 58V6c0-1-.8-1.9-1.9-1.9H66c-1 0-1.9.8-1.9 1.9v53.8H118c1 0 1.8-.8 1.8-1.8"
                            />
                            <path
                                fill="#0063fc"
                                d="M22.5 4.2H6C5 4.2 4.2 5 4.2 6v52c0 1 .8 1.9 1.9 1.9H60V41.5C59.9 20.9 43.2 4.2 22.5 4.2"
                            />
                            <path
                                fill="#fff"
                                d="M118 0H66c-3.3 0-6 2.7-6 6v17.4C53.2 9.6 38.9 0 22.5 0H6C2.7 0 0 2.7 0 6v52c0 3.3 2.7 6 6 6h112c3.3 0 6-2.7 6-6V6c0-3.3-2.7-6-6-6m1.8 58c0 1-.8 1.9-1.9 1.9H64.1V6c0-1 .8-1.9 1.9-1.9h52c1 0 1.9.8 1.9 1.9v52zM4.2 58V6C4.2 5 5 4.2 6 4.2h16.5c20.6 0 37.4 16.8 37.4 37.4v18.3H6c-1-.1-1.8-.9-1.8-1.9"
                            />
                        </svg>
                    </span>
                    <span class="flex items-center">
                        <span class="hidden sm:block">
                            <svg
                                focusable="false"
                                width="92"
                                height="32"
                                viewBox="0 0 184 64"
                            >
                                <title>FINN.no</title>
                                <path
                                    fill="#06bffc"
                                    d="M179.8 58V6c0-1-.8-1.9-1.9-1.9H66c-1 0-1.9.8-1.9 1.9v53.8H178c1 0 1.8-.8 1.8-1.8"
                                ></path>
                                <path
                                    fill="#0063fc"
                                    d="M22.5 4.2H6C5 4.2 4.2 5 4.2 6v52c0 1 .8 1.9 1.9 1.9H60V41.5C59.9 20.9 43.2 4.2 22.5 4.2"
                                ></path>
                                <path
                                    fill="#fff"
                                    d="M178 0H66c-3.3 0-6 2.7-6 6v17.4C53.2 9.6 38.9 0 22.5 0H6C2.7 0 0 2.7 0 6v52c0 3.3 2.7 6 6 6h172c3.3 0 6-2.7 6-6V6c0-3.3-2.7-6-6-6m1.8 58c0 1-.8 1.9-1.9 1.9H64.1V6c0-1 .8-1.9 1.9-1.9h112c1 0 1.9.8 1.9 1.9v52zM4.2 58V6C4.2 5 5 4.2 6 4.2h16.5c20.6 0 37.4 16.8 37.4 37.4v18.3H6c-1-.1-1.8-.9-1.8-1.9"
                                ></path>
                                <path
                                    fill="#fff"
                                    d="M110.1 21.1h-4.2c-.7 0-1.2.5-1.2 1.2v19.3c0 .7.5 1.2 1.2 1.2h4.2c.7 0 1.2-.5 1.2-1.2V22.3c0-.6-.6-1.2-1.2-1.2m-12 0H83c-.7 0-1.2.5-1.2 1.2v19.3c0 .7.5 1.2 1.2 1.2h4.2c.7 0 1.2-.5 1.2-1.2v-4h7.7c.7 0 1.2-.5 1.2-1.2v-3.2c0-.7-.5-1.2-1.2-1.2h-7.7v-4.9h9.7c.7 0 1.2-.5 1.2-1.2v-3.7c0-.5-.6-1.1-1.2-1.1m62.8 0h-4.2c-.7 0-1.2.5-1.2 1.2v9.5l-6.6-10c-.3-.4-.8-.7-1.3-.7h-3.2c-.7 0-1.2.5-1.2 1.2v19.3c0 .7.5 1.2 1.2 1.2h4.2c.7 0 1.2-.5 1.2-1.2v-9.4l6.5 9.8c.3.4.8.7 1.3.7h3.4c.7 0 1.2-.5 1.2-1.2V22.3c-.1-.6-.6-1.2-1.3-1.2m-25.4 0h-4.2c-.7 0-1.2.5-1.2 1.2v9.5l-6.6-10c-.3-.4-.8-.7-1.3-.7H119c-.7 0-1.2.5-1.2 1.2v19.3c0 .7.5 1.2 1.2 1.2h4.2c.7 0 1.2-.5 1.2-1.2v-9.4l6.5 9.8c.3.4.8.7 1.3.7h3.4c.7 0 1.2-.5 1.2-1.2V22.3c-.1-.6-.6-1.2-1.3-1.2"
                                ></path>
                            </svg>
                        </span>
                        <span
                            class="font-bold text-12 ml-8 s-text-default hidden md:block"
                            >${this.i18n.t({
                                id: 'topbar.subtitle',
                                message: 'Market of opportunities',
                                comment:
                                    'The subtitle used after the brand name',
                            })}</span
                        >
                        <span> </span
                    ></span>
                `;
        }
    }

    render() {
        const finnLogoAriaLabel = this.i18n.t({
            id: 'topbar.header.logo.aria-label',
            message:
                'the FINN.no logo shows the name FINN written in white text in a light blue rectangle to the right of a dark blue quarter circle.',
            comment: 'Aria label for the FINN.no logo',
        });
        const frontpageText = this.i18n.t({
            id: 'topbar.header.frontpage.link.aria-label',
            message: 'Frontpage',
            comment:
                'Aria label and title used for the frontpage link in the header ',
        });
        const newAdText = this.i18n.t({
            id: 'topbar.header.new-ad.link',
            message: 'New ad',
            comment: 'Text for the new ad link in the header',
        });
        const messagesText = this.i18n.t({
            id: 'topbar.header.messages.text',
            message: 'Messages',
            comment: 'Text for the messages link in the header',
        });

        return html`
            <header
                class="s-bg-default border-b s-border-default w-full fixed z-20"
                data-browser-warning="true"
            >
                <span role="img" aria-label="${finnLogoAriaLabel}"></span>
                <nav
                    class="bg-inherit page-container flex notranslate"
                    style="height:49px"
                    aria-label="Topp"
                >
                    <a
                        href="${this._origin}"
                        class="flex items-center pt-2 border-b-2 border-transparent hover:s-border-primary-default focus:s-border-primary-default focus:outline-none text-grey-800 mr-auto no-underline hover:no-underline focus:no-underline active:no-underline "
                        aria-current="${this.activeMenuItem ===
                        menuItem.FRONTPAGE
                            ? 'page'
                            : 'false'}"
                        aria-label="${frontpageText}"
                        data-automation-id="frontpage-link"
                        title="${frontpageText}"
                    >
                        ${this._logo}
                    </a>
                    ${this.distractionFree
                        ? ''
                        : html`
                              <a
                                  id="top-bar_notifications-link"
                                  href="${this._origin}/notifications"
                                  class="${this.activeMenuItem ===
                                  menuItem.NOTIFICATIONS
                                      ? 's-border-primary-default'
                                      : 'border-transparent'} justify-center p-0 flex-auto md:flex-none relative no-wrap min-width-0 py-0 px-10 ml-10 border-b-2 hover:s-border-primary-default focus:s-border-primary-default focus:outline-none flex items-center text-12 no-underline hover:no-underline focus:no-underline active:no-underline"
                                  aria-current="${this.activeMenuItem ===
                                  menuItem.NOTIFICATIONS
                                      ? 'page'
                                      : 'false'}"
                                  aria-label="${this.i18n.t({
                                      id: 'topbar.notifications.link.aria-label',
                                      message: 'Notifications',
                                      comment:
                                          'The aria-label used for the notifications link when the user has no notifications',
                                  })}"
                                  data-automation-id="notifications-link"
                                  title="${this.i18n.t({
                                      id: 'topbar.notifications.link.title',
                                      message: 'Notifications',
                                      comment:
                                          'The title for the notifications link',
                                  })}"
                                  rel="nofollow"
                              >
                                  <f-icon-bell24
                                      class="-mb-4 ${this.activeMenuItem ===
                                      menuItem.NOTIFICATIONS
                                          ? 's-icon-primary'
                                          : 's-text-subtle'}"
                                  ></f-icon-bell24>
                                  <notification-bubble
                                      ?show="${this.hasNotifications}"
                                  ></notification-bubble>
                                  <span
                                      class="hidden md:block ml-8 s-text-default translate font-bold"
                                      style="color: #474445;"
                                      >${this.i18n.t({
                                          id: 'topbar.notifications.link.text',
                                          message: 'Notifications',
                                          comment:
                                              'The link text used on the notifications button',
                                      })}</span
                                  >
                              </a>
                              <a
                                  href="${this._origin}/innfinn"
                                  class="${this.activeMenuItem ===
                                  menuItem.NEW_AD
                                      ? 's-border-primary-default'
                                      : 'border-transparent'} justify-center p-0 flex-auto md:flex-none relative no-wrap min-width-0 py-0 px-10 ml-10 border-b-2 hover:s-border-primary-default focus:s-border-primary-default focus:outline-none flex items-center text-12 no-underline hover:no-underline focus:no-underline active:no-underline "
                                  aria-current="${this.activeMenuItem ===
                                  menuItem.NEW_AD
                                      ? 'page'
                                      : 'false'}"
                                  aria-label="${newAdText}"
                                  data-automation-id="new-ad-link"
                                  title="${newAdText}"
                                  @click="${this._trackEventNewAd}"
                                  rel="nofollow"
                              >
                                  <f-icon-circle-plus24
                                      class="-mb-4 ${this.activeMenuItem ===
                                      menuItem.NEW_AD
                                          ? 's-icon-primary'
                                          : 's-text-subtle'}"
                                  ></f-icon-circle-plus24>
                                  <span
                                      class="hidden md:block ml-8 s-text-default translate font-bold"
                                      style="color: #474445;"
                                      >${newAdText}</span
                                  >
                              </a>

                              <a
                                  id="top-bar_messages-link"
                                  href="${this._origin}/messages"
                                  class="${this.activeMenuItem ===
                                  menuItem.INBOX
                                      ? 's-border-primary-default'
                                      : 'border-transparent'} justify-center p-0 flex-auto md:flex-none relative no-wrap min-width-0 py-0 px-10 ml-10 border-b-2 hover:s-border-primary-default focus:s-border-primary-default focus:outline-none flex items-center text-12 text-blue-500 no-underline hover:no-underline focus:no-underline active:no-underline"
                                  aria-current="${this.activeMenuItem ===
                                  menuItem.INBOX
                                      ? 'page'
                                      : 'false'}"
                                  aria-label="${messagesText}"
                                  data-automation-id="inbox-link"
                                  title="${messagesText}"
                                  rel="nofollow"
                              >
                                  <f-icon-messages24
                                      class="-mb-4 ${this.activeMenuItem ===
                                      menuItem.INBOX
                                          ? 's-icon-primary'
                                          : 's-text-subtle'}"
                                  ></f-icon-messages24>
                                  <messages-bubble
                                      ?show="${this.messagesUnreadCount > 0}"
                                  ></messages-bubble>
                                  <span
                                      class="hidden md:block ml-8 s-text-default translate font-bold"
                                      style="color: #474445;"
                                      >${messagesText}</span
                                  >
                              </a>

                              ${this.legacyHeader
                                  ? this._legacyProfile
                                  : this._megaMenuButton}
                          `}
                </nav>
            </header>
            ${this._megaMenu}
        `;
    }
}

customElements.define('finn-topbar', FinnTopbar);
